<div class="notification">
  <div class="indicator">
    @if (isError()) {
      <cq-icon-symbol
        name="error"
        [fill]="true"
        class="message-icon"
      ></cq-icon-symbol>
    } @else if (isInfo()) {
      <cq-icon-symbol
        name="info"
        [fill]="true"
        class="message-icon"
      ></cq-icon-symbol>
    } @else if (isWarning()) {
      <cq-icon-symbol
        name="warning"
        [fill]="true"
        class="message-icon"
      ></cq-icon-symbol>
    }
  </div>
  <div class="message">{{ message() }}</div>
  <div class="duration">
    <mat-spinner
      class="spinner"
      mode="determinate"
      [diameter]="36"
      [strokeWidth]="4"
      [value]="elapsed | async"
    ></mat-spinner>
    <button
      class="dismiss"
      mat-icon-button
      aria-label="dismiss"
      (click)="dismiss()"
    >
      <cq-icon-symbol name="close" class="close-icon"></cq-icon-symbol>
    </button>
  </div>
</div>
